var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "grid__row" },
    [
      _c("ma-input-btn", {
        attrs: {
          type: "btn",
          value: _vm.optionSelected,
          options: _vm.options,
          name: "toggleButton",
          col: "2",
          literal: _vm.$t("warrantyProps.propertyType.literal")
        },
        on: {
          change: function($event) {
            return _vm.handleButtonClick($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }